import { create } from "zustand";

interface DiagnosticStore {
  selectedDiagnosticField: string | null;
  setSelectedDiagnosticField: (field: string | null) => void;
  openedPopoverField: string | null;
  setOpenedPopoverField: (field: string | null) => void;
}

export const useDiagnosticStore = create<DiagnosticStore>((set) => ({
  selectedDiagnosticField: null,
  setSelectedDiagnosticField: (field: string | null) =>
    set({ selectedDiagnosticField: field }),
  openedPopoverField: null,
  setOpenedPopoverField: (field: string | null) =>
    set({ openedPopoverField: field }),
}));
